import styled from "styled-components";
import { Menu } from "../../../data/types/Menu";
import { size } from "../../../style/util/size";
import { rgba } from "polished";
import { GlascLogo } from "../../general/GlascLogo/GlascLogo";
import { device, hover } from "../../../style/util/media-query";
import {
  GlascLogoHeightLarge,
  GlascLogoHeightSmall,
  GlascLogoPadding,
} from "../../general/GlascLogo/GlascLogo.styled";

export const transitionInDuration = 1;
export const transitionOutDuration = 0.5;
export const mobileTransitionOutDuration = 0;

export const StyledContentContainer = styled.div<{
  $transitionOut: boolean;
  $alignCenter?: boolean;
}>`
  min-height: 100vh;
  opacity: ${({ $transitionOut }) => ($transitionOut ? "0" : "1")};
  transition: opacity
    ${({ $transitionOut }) =>
      $transitionOut ? mobileTransitionOutDuration : transitionInDuration}s
    ease-out;

  ${({ $alignCenter }) =>
    $alignCenter &&
    `display: flex;
    align-items: center;`};

  @media ${device.desktop} {
    display: flex;
    align-items: center;
    height: 100%;
    transition-duration: ${({ $transitionOut }) =>
      $transitionOut ? transitionOutDuration : transitionInDuration}s;
  }
`;

export const StyledBackground = styled.div<{ $activeId: Menu }>`
  ${size("100%")};
  position: fixed;
  background-color: ${({ theme, $activeId }) =>
    rgba(theme.colors.black, $activeId === "products" ? 1 : 0.85)};
  pointer-events: none;
  opacity: ${({ $activeId }) => (!!$activeId ? "1" : "0")};
  transition: opacity ${transitionOutDuration}s,
    background-color ${transitionOutDuration}s;
`;

export const StyledGlascLogo = styled(GlascLogo)<{ $activeId: Menu }>`
  top: 0;
  width: 15rem;
  margin: calc((${GlascLogoPadding} + ${GlascLogoHeightSmall}) * -1) auto 0;
  ${({ $activeId }) =>
    $activeId === "" ? `pointer-events: none;` : `cursor: pointer;`};

  @media ${hover} {
    svg {
      overflow: visible;
    }

    path {
      &:nth-of-type(1) {
        transition: transform 0.5s ease-out;
      }

      &:nth-of-type(2) {
        transition: fill 0.5s;
      }
    }

    &:hover {
      path {
        &:nth-of-type(1) {
          transform: translateY(-5%);
        }

        &:nth-of-type(2) {
          fill: ${({ theme }) => theme.colors.magenta};
        }
      }
    }
  }

  @media ${device.desktopL} {
    width: 23rem;
    margin-top: calc((${GlascLogoPadding} + ${GlascLogoHeightLarge}) * -1);
  }
`;
